export const TypesFieldEnum = Object.freeze({
  SELECTION: 'selection',
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  DATE: 'date',
  BIRTH_DATE: 'birth_date',
  TEL: 'tel',
  SSN: 'ssn',
  ADDITIONAL_ADDRESS: 'additional_address',
});
